/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './surgical-history.reducer';

export const SurgicalHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const surgicalHistoryEntity = useAppSelector(state => state.surgicalHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="surgicalHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.surgicalHistory.detail.title">SurgicalHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.surgicalHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{surgicalHistoryEntity.id}</dd>
          <dt>
            <span id="surgeryDate">
              <Translate contentKey="tinyMedicRestApp.surgicalHistory.surgeryDate">Surgery Date</Translate>
            </span>
          </dt>
          <dd>{surgicalHistoryEntity.surgeryDate}</dd>
          <dt>
            <span id="surgeryDetails">
              <Translate contentKey="tinyMedicRestApp.surgicalHistory.surgeryDetails">Surgery Details</Translate>
            </span>
          </dt>
          <dd>{surgicalHistoryEntity.surgeryDetails}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.surgicalHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{surgicalHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.surgicalHistory.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{surgicalHistoryEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.surgicalHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{surgicalHistoryEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.surgicalHistory.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{surgicalHistoryEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.surgicalHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{surgicalHistoryEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.surgicalHistory.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{surgicalHistoryEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surgicalHistory.patient">Patient</Translate>
          </dt>
          <dd>{surgicalHistoryEntity.patient ? surgicalHistoryEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/surgical-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/surgical-history/${surgicalHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SurgicalHistoryDetail;
